// extracted by mini-css-extract-plugin
export default {"badgeContainer":"RelatedWorkspaceEdit_badgeContainer__K1Npt"};